<template>
    <v-select
        v-model="time"
        :items="times"
        :label="label"
        :outlined="outlined"
        :dense="dense"
        @change="changed"
    ></v-select>
</template>
<script>
export default {
    props: {
        value: {
            type: Number,
            required: true,
        },
        label: {
            type: String,
            required: false,
            default: null,
        },
        interval: {
            type: Number,
            required: false,
            default: 30,
        },
        outlined: {
            type: Boolean,
            required: false,
        },
        dense: {
            type: Boolean,
            required: false,
        },
        zeroPadDisplay: {
            type: Boolean,
            required: false,
            default: true,
        },
    },
    data() {
        return {
            time: 0,
        }
    },
    watch: {
        value: {
            immediate: true,
            handler(val) {
                this.time = val
            },
        },
    },
    computed: {
        times() {
            //30 minute intervals
            let times = []
            for (let i = 0; i < 48; i++) {
                times.push({
                    text: `${this.zeroPadDisplay ? this.zeroPad(Math.floor(i / 2)) : Math.floor(i / 2)}:${this.zeroPad(
                        (i % 2) * 30,
                    )}`,
                    value: i * 30,
                })
            }
            return times
        },
    },
    methods: {
        zeroPad(value) {
            return ('0' + value).slice(-2)
        },
        changed() {
            this.$emit('input', this.time)
            this.$emit('change', this.time)
        },
    },
}
</script>
